import LeftPseudoBox from './LeftPseudoBox';
import RightPseudoBox from './RightPseudoBox';

export const LeftPseudo = LeftPseudoBox;
export const RightPseudo = RightPseudoBox;
